'use strict';
const wordWrap = require('./word-wrap'),
	fontMetrics = require('./font-metrics'),
	direction = require('direction'),
	svgMarkupBuilder = require('./markup-builder').svgMarkupBuilder,
	fontFamiliesBuilder = require('@mindmup/mapjs-core/src/theme/font-families'),
	cssFontFamilies = fontFamiliesBuilder();
module.exports = function createTspanTextWriter(widthFunction, lineBreaker, textWriterOptions) {
	const tspanTextWriter = function tspanTextWriter(nodeView) {
		const font = fontMetrics(nodeView.theme.font),
			fontFamilies = (textWriterOptions && textWriterOptions.fontFamilies) || cssFontFamilies,
			txWidth = function (text) {
				const width =  widthFunction(text, font);
				return Math.ceil(width * font.fontSize);
			},
			lineHeight = Math.ceil(font.fontSize + font.lineSpacing),
			textElement = svgMarkupBuilder('text').css({
				fill: nodeView.theme.text.color
			}).attr({
				'font-family': fontFamilies[font.family],
				'font-size': font.fontSize,
				'font-weight': font.weight,
				lengthAdjust: 'spacingAndGlyphs'
			}),
			wrappedText = wordWrap(nodeView.title, nodeView.metrics.text.width, txWidth, lineBreaker);
		wrappedText.forEach((textLine, index) => {
			const attrs =  {
					y: nodeView.metrics.text.y + (lineHeight * index) + font.fontSize,
					x: Math.ceil(nodeView.metrics.text.x + nodeView.metrics.text.width / 2),
					'text-anchor': 'middle',
					textLength: Math.floor(textLine.width)
				},
				nodethemeText = nodeView.theme.text;
			if (nodethemeText.alignment === 'right') {
				attrs['text-anchor'] = 'end';
				attrs.x = Math.ceil(nodeView.metrics.text.x + nodeView.metrics.text.width);
			} else if (nodethemeText.alignment === 'left') {
				attrs['text-anchor'] = 'start';
				attrs.x = nodeView.metrics.text.x;
			} else if (nodethemeText.alignment === 'start') {
				if (direction(textLine.text) === 'rtl') {
					attrs['text-anchor'] = 'end';
					attrs.x = Math.ceil(nodeView.metrics.text.x + nodeView.metrics.text.width);
					attrs['font-size'] = Math.floor(font.fontSize * 0.9);
				} else {
					attrs['text-anchor'] = 'start';
					attrs.x = nodeView.metrics.text.x;
				}
			}
			if (textWriterOptions && textWriterOptions.dontSpecifyLength) {
				delete attrs.textLength;
			}
			svgMarkupBuilder('tspan').attr(attrs).text(textLine.text).appendTo(textElement);
		});
		return textElement;
	};
	return tspanTextWriter;
};
